import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { REGION_ENVIRONMENT } from 'SharedDir/constants/common';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const staticDocsUrl = `${SERVER_API}/static/docs`;

export const STATIC_DOCS = {
  MANUAL_USER: {
    method: 'GET',
    url: `${staticDocsUrl}/${REGION_ENVIRONMENT}/Руководство пользователя КМНС.pdf`,
  } as IEndpointData,
  MANUAL_ADMINISTRATOR: {
    method: 'GET',
    url: `${staticDocsUrl}/${REGION_ENVIRONMENT}/Руководство администратора КМНС.pdf`,
  } as IEndpointData,
  PRIVACY_POLICY: {
    method: 'GET',
    url: `${staticDocsUrl}/${REGION_ENVIRONMENT}/privacy_policy.pdf`,
  } as IEndpointData,
  AGREEMENT_PERSONAL_DATA: {
    method: 'GET',
    url: `${staticDocsUrl}/${REGION_ENVIRONMENT}/agreement_personal_data.pdf`,
  } as IEndpointData,
  REGULATIONS_ON_PERSONAL_DATA_PROCESSING: {
    method: 'GET',
    url: `${staticDocsUrl}/${REGION_ENVIRONMENT}/Положение об обработке ПДн.pdf`,
  } as IEndpointData,
  DESCRIPTION_API_METHOD: {
    method: 'GET',
    url: `${staticDocsUrl}/Описание методов API ГИС КМНС.pdf`,
  } as IEndpointData,
  VIDEOINSTRUCTION_IN_CLOUD: {
    method: 'GET',
    url: 'https://cloud.uriit.ru/s/zdq6tp95dOtWjHC',
  } as IEndpointData,
};
